export { default } from './router-progress'
